import { http } from '@/http'

export default {
  list(params) {
    return http.get('/cessation-reasons', { params })
  },
  listByType(type) {
    return http.get('/cessation-reasons', { params: { type, status: 1 } })
  },
  listTypes() {
    return http.get('/cessation-reasons/types')
  },
  get(id) {
    return http.get(`/cessation-reasons/${id}`)
  },
  save(data) {
    return http.post('/cessation-reasons', data)
  },
  update(id, data) {
    return http.put(`/cessation-reasons/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/cessation-reasons/${id}/status`, null, { params: { status } })
  },
}
